/**
 * Code-facing design tokens. CSS-facing tokens live in styles.css; values
 * needed by native colour inputs and data-driven inline styles live here so
 * PM and HR never define their own palettes.
 */
export const dataColors = {
  groupDefault: '#1B4FA8',
  avatars: ['#348AF3', '#7B61FF', '#1F9D6C', '#F2A93B', '#D53A32', '#121D35'],
  statusLabels: ['#C4C4C4', '#FDAB3D', '#E2445C', '#00C875', '#1B4FA8', '#7B61FF'],
  /** Chart slices with no colour of their own - people, groups, boards, free text. */
  charts: ['#348AF3', '#1F9D6C', '#F2A93B', '#D53A32', '#7B61FF', '#12275B', '#66CCFF', '#CAB641', '#9AADBD', '#E8112D'],
} as const;
